import React from 'react';
import { Editor } from '@monaco-editor/react';

const SimpleEditor = ({ value, onChange, editable }) => {
  return (
    <div style={{ height: '23rem' }}>
      <Editor
        height="100%"
        defaultLanguage="json" // Altere conforme necessário
        value={value} // Valor inicial do editor
        onChange={onChange} // Callback para capturar mudanças no texto
        options={{
          readOnly: !editable,
          minimap: { enabled: false }, // Desativa minimapa
          lineNumbers: 'on', // Exibe números das linhas
          wordWrap: 'on', // Ativa quebra de linha automática
          scrollBeyondLastLine: false, // Evita espaço extra no final
        }}
      />
    </div>
  );
};

export default SimpleEditor;
